import { useEffect, useRef, useState } from "react";
import { SEARCH_PLACEHOLDER } from "@/utils/constants/constants";

interface Props {
    onHide: () => void;
    handleSearch?: (searchText: string) => void;
    reset?: () => void;
    title: string;
    id: string;
}

const SearchBar = (props: Props) => {
    const { onHide, reset, handleSearch, title } = props;
    const [searchText, setSearchText] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const handleClearSearch = () => {
        onHide();
        setSearchText("");
        reset?.();
    };

    const [prevTitle, setPrevTitle] = useState(title);

    useEffect(() => {
        if (title !== prevTitle) {
            handleClearSearch();
        }
        setPrevTitle(title);
    }, [title]);

    const submitSearch = () => {
        handleSearch?.(searchText.trim());
    };

    return (
        <div className="gs-search-bar">
            <div className="gs-search-bar__inner">
                <button
                    type="button"
                    id={`${props.id}-cross-icon`}
                    className="gs-search-bar__close"
                    onClick={handleClearSearch}
                    aria-label="Close search"
                >
                    <em className="icon ni ni-cross" />
                </button>
                <input
                    type="text"
                    id={`${props.id}-search-input`}
                    ref={inputRef}
                    value={searchText}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            submitSearch();
                        }
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="gs-search-bar__input"
                    placeholder={SEARCH_PLACEHOLDER}
                />
                <button
                    type="button"
                    id={`${props.id}-search-input-icon`}
                    className="gs-search-bar__submit"
                    onClick={submitSearch}
                    aria-label="Search"
                >
                    <em className="icon ni ni-search" />
                </button>
            </div>
        </div>
    );
};

export default SearchBar;
